<template>
  <div class="d-flex align-center justify-center">
    <button :disabled="disabled" @click="openDrawer">
      <v-badge
        :content="filterSelectedCount"
        :value="filterSelectedCount"
        color="#A50200"
      >
        <v-icon size="34" :color="disabled ? '#C4C4C4' : '#A50200'">
          mdi-filter-outline
        </v-icon>
      </v-badge>
    </button>
    <v-navigation-drawer v-model="drawer" width="400" fixed right temporary>
      <div class="d-flex flex-column h-100">
        <div style="flex: 1; padding-top: 70px">
          <section
            class="px-6 py-8 d-flex align-center justify-space-between"
            style="background-color: #e1e1e1"
          >
            <span class="font-18 font-w-500">กรองการค้นหา</span>
            <button @click="drawer = false">
              <v-icon>mdi-close</v-icon>
            </button>
          </section>
        </div>

        <div style="flex-basis: 100%; overflow-y: auto">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div class="d-flex py-3">
                  <v-badge
                    :content="groupList.length"
                    color="#A50200"
                    size="30"
                    offset-x="-5"
                    offset-y="16"
                  >
                    <span class="font-16 font-w-500">หมวดหมู่</span>
                  </v-badge>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div>
                  <v-text-field
                    v-model="groupSearch"
                    class="v-text-field-custom"
                    placeholder="ค้นหา"
                    append-icon="mdi-magnify"
                    solo
                    flat
                  ></v-text-field>
                </div>
                <div class="d-flex flex-wrap overflow-y-auto">
                  <v-col
                    v-for="(group, index) in groupListFilter"
                    :key="index"
                    cols="6"
                  >
                    <div
                      class="box-item"
                      :class="{ 'box-item--selected': group.selected }"
                      @click="group.selected = !group.selected"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span class="line-clamp-3" v-bind="attrs" v-on="on">
                            {{ group.class_name }}
                          </span>
                        </template>
                        <span>{{ group.class_name }}</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>
                <div class="d-flex py-3">
                  <v-badge
                    :content="brandList.length"
                    color="#A50200"
                    size="30"
                    offset-x="-5"
                    offset-y="16"
                  >
                    <span class="font-16 font-w-500">Brand</span>
                  </v-badge>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div>
                  <v-text-field
                    v-model="brandSearch"
                    class="v-text-field-custom"
                    placeholder="ค้นหา"
                    append-icon="mdi-magnify"
                    solo
                    flat
                  ></v-text-field>
                </div>
                <div class="d-flex flex-wrap overflow-y-auto">
                  <v-col
                    v-for="(brand, index) in brandListFilter"
                    :key="index"
                    cols="6"
                  >
                    <div
                      class="box-item"
                      :class="{ 'box-item--selected': brand.selected }"
                      @click="brand.selected = !brand.selected"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span class="line-clamp-3" v-bind="attrs" v-on="on">
                            {{ brand.name }}
                          </span>
                        </template>
                        <span>{{ brand.name }}</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <div style="flex: 1">
          <v-divider class="ma-0" />
          <div class="d-flex gap-20 pa-5">
            <button
              class="btn-grey-outline w-100 py-4 font-16 font-w-500"
              @click="clearFilter"
            >
              ล้างฟิลเตอร์
            </button>
            <button
              class="btn-red w-100 py-4 font-16 font-w-500"
              @click="submitFilter"
            >
              ตกลง
            </button>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  props: {
    customerId: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      drawer: false,
      groupSearch: '',
      groupList: [],
      brandSearch: '',
      brandList: [],
    }
  },
  watch: {
    customerId(newValue, oldValue) {
      // clear filter when customer changed
      this.clearFilter()
    },
  },
  computed: {
    groupListFilter() {
      return this.groupList.filter((item) => {
        return item.class_name
          .toLowerCase()
          .includes(this.groupSearch.toLowerCase())
      })
    },
    groupSelected() {
      return this.groupList.filter((item) => item.selected)
    },
    brandListFilter() {
      return this.brandList.filter((item) => {
        return item.name.toLowerCase().includes(this.brandSearch.toLowerCase())
      })
    },
    brandSelected() {
      return this.brandList.filter((item) => item.selected)
    },
    filterSelectedCount() {
      return this.groupSelected.length + this.brandSelected.length
    },
  },
  methods: {
    openDrawer() {
      if (this.groupList.length === 0 || this.brandList.length === 0) {
        this.getProductGroupTarget()
        this.getProductBrandTarget()
      }
      this.drawer = true
    },
    callbackFilters() {
      this.$emit('callbackFilters', {
        group: this.groupSelected,
        brand: this.brandSelected,
      })
    },
    clearFilter() {
      this.groupSearch = ''
      this.groupList = []
      this.brandSearch = ''
      this.brandList = []
      this.drawer = false
      this.callbackFilters()
    },
    submitFilter() {
      this.drawer = false
      this.callbackFilters()
    },
    async getProductGroupTarget() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/product/productGroupTarget`,
          {
            customer_id: this.customerId,
          },
          { headers: this.setheaders },
        )
        this.groupList = res.data.items.map((item) => ({
          ...item,
          selected: false,
        }))
      } catch (error) {}
    },
    async getProductBrandTarget() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/product/productBrandTarget`,
          {
            customer_id: this.customerId,
          },
          { headers: this.setheaders },
        )
        this.brandList = res.data.items.map((item) => ({
          ...item,
          selected: false,
        }))
      } catch (error) {}
    },
  },
}
</script>

<style lang="scss" scoped>
.box-item {
  border: 1px solid #dedede;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  height: 100px;
  cursor: pointer;
  user-select: none;

  &--selected {
    border: 1px solid #ac0300;
    background-color: #f7e6e5;
  }
}
</style>
